module.exports = __webpack_public_path__ + "img/soft-drink.8e411b6.png";